import { render, staticRenderFns } from "./CustomerTwitter.vue?vue&type=template&id=6f914f61"
import script from "./CustomerTwitter.vue?vue&type=script&lang=js"
export * from "./CustomerTwitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports